import React from 'react';

const ScreenshotTheme = {
  headerLogo: {
    src: '/themes/theme/screenshot/logo.png',
    alt: 'SCREENSHOT influencers',
  },
  darkLogo: {
    src: '/themes/theme/screenshot/logo.png',
    alt: 'SCREENSHOT influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'SCREENSHOT | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/screenshot/logo.png" alt="SCREENSHOT Influencers" />
      <br />
    </div>
  ),
  shareSite: 'https://share.screenshotmedia.co',
};

export default ScreenshotTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/screenshot.js
 **/